import { getEnvRequired } from '../../shared/utilities/env';

const GOOGLE_CALENDAR_SCOPE = 'https://www.googleapis.com/auth/calendar';

export function buildGoogleOAuthUrl(): string {
    const basePath = getEnvRequired('APP_BASENAME');
    const clientId = getEnvRequired('GOOGLE_OAUTH_CLIENT_ID');
    const callbackUrl = `${window.location.origin}${basePath}/calendar/callback`;
    const params = new URLSearchParams({
        client_id: clientId,
        redirect_uri: callbackUrl,
        response_type: 'code',
        scope: GOOGLE_CALENDAR_SCOPE,
        access_type: 'offline',
    });
    return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}
